import { useContext } from "react";

import { NewDealJourneyContext } from "../../../NewDealJourneyContext";

interface UseInvestmentDetails {
  handleValidateAndNext: (saveData: boolean) => Promise<boolean>;
}

export const useInvestmentDetails = (): UseInvestmentDetails => {
  const { handleValidateAndNext } = useContext(NewDealJourneyContext);

  return {
    handleValidateAndNext,
  };
};
